import { Alert, Card, CardBody, CardHeader } from '@trussworks/react-uswds';

import GeneratePDF from './components/GeneratePDF.jsx';
import NotFound from '../NotFound/index.jsx';
import BannerSettings from './components/BannerSettings.jsx';
import ManageVersion from './components/ManageVersion.jsx';
import EndpointCheck from './components/EndpointCheck.jsx';
import EnvironmentVariablesCheck from './components/EnvironmentVariablesCheck.jsx';
import JpaFileMetadataSync from './components/JpaFileMetadataSync.jsx';
import { useUserRoleCapabilities } from '@stores';
import './developerDashboard.scss';
import TransferUserProjects from './components/TransferUserProjects.jsx';

const DeveloperDashboard = () => {
  const canViewDeveloperTab = useUserRoleCapabilities((state) => state.roleCapabilities.viewDeveloperTab);

  return (
    <>
      {canViewDeveloperTab ? (
        <div className='content-container'>
          <h1>RRS Developer Dashboard</h1>
          <Card className='general-support-card'>
            <CardHeader>
              <h4>Manual PDF Generation</h4>
            </CardHeader>
            <CardBody>
              Regenerate submitted requests PDFs by providing the Project ID, Request ID, and Version in the field
              below.
              <GeneratePDF />
            </CardBody>
          </Card>
          <Card className='general-support-card'>
            <CardHeader>
              <h3>Transfer RRS Projects</h3>
            </CardHeader>
            <CardBody>
              Transfer RRS Projects from one user to another via Project Ownership
              <TransferUserProjects />
            </CardBody>
          </Card>
          <Card className='feedback-card'>
            <CardHeader>
              <h4>JPA File Metadata Sync</h4>
            </CardHeader>
            <CardBody>
              Sync JPA file metadata by providing the Created Date in the field below.<br></br>{' '}
              <i>This will sync JPA Files for JPA Forms that were altered from the provided date onwards.</i>
              <JpaFileMetadataSync />
            </CardBody>
          </Card>
          <Card className='office-support-card'>
            <CardHeader>
              <h4>Maintenance Banner Control Center</h4>
            </CardHeader>
            <CardBody>
              <p>Post and/or enable/disable maintenance banner</p>
              <Alert noIcon slim heading='Example' headingLevel='h5' className='callout margin-bottom-3'>
                The Regulatory Request System (RRS) will be down for scheduled maintenance on 7/3/2024 starting at 6:00
                P.M. Eastern Standard Time. Estimated downtime will be approximately 15-30 minutes.
              </Alert>
              <BannerSettings />
            </CardBody>
          </Card>
          <Card className='feedback-card'>
            <CardHeader>
              <h3>Manual Version Number Update</h3>
            </CardHeader>
            <CardBody>
              <p>Manually update RRS release version number.</p>
              <ManageVersion />
            </CardBody>
          </Card>
          <Card className='logingov-card'>
            <CardHeader>
              <h3>External API Statuses</h3>
            </CardHeader>
            <CardHeader>
              <p>Manually check ORM/external APIs are reachable.</p>
              <EndpointCheck />
            </CardHeader>
          </Card>
          <Card className='env-card'>
            <CardHeader>
              <h3>Required Environment Variables</h3>
            </CardHeader>
            <CardHeader>
              <p>Manually check if all required Environment Variables are present.</p>
              <EnvironmentVariablesCheck />
            </CardHeader>
          </Card>
        </div>
      ) : (
        <NotFound />
      )}
    </>
  );
};

export default DeveloperDashboard;
